<template>
  <div>
    <component
      :is="loadedFeedbackComponent"
      v-if="loadedFeedbackComponent"
      :is-shown="true"
      v-bind="feedbackComponentProps"
      @update:is-shown="onClose()"
    />
  </div>
</template>

<script lang="ts" setup>
import { FeedbackEvent } from '~/const'; // Assuming this path is correct
console.log('FeedbackDialogWrapper loaded');
// Reactive variables to hold the data received from the event
const feedbackComponentProps = shallowRef<{
  appointmentId?: number;
  serviceType?: string;
} | null>(null);

// This ref will hold the asynchronously loaded component definition itself.
// It will be null initially and assigned ONLY when the event triggers.
const loadedFeedbackComponent = shallowRef<Component | null>(null);

const onClose = () => {
  loadedFeedbackComponent.value = null;
  console.log('Feedback component closed');
};

// @ts-expect-error // Assuming useEvent might not have perfect type inference for its arguments
useEvent(FeedbackEvent, (eventPayload: FeedbackEventPayload) => {
  console.log('Feedback event received:', eventPayload);
  // 1. Assign the data from the event

  feedbackComponentProps.value = {
    appointmentId: eventPayload.appointmentId || undefined,
    serviceType: eventPayload.serviceType || undefined,
  };
  // 2. Define the async component AT THE MOMENT THE EVENT TRIGGERS
  // This is where the actual 'import()' call (and thus code fetching) happens
  // only when this event listener executes.
  nextTick(() => {
    loadedFeedbackComponent.value = defineAsyncComponent(
      {
        loader: () => import('./FeedbackDialog.vue'),
        onError(error, retry, fail, attempts) {
          console.error('Error loading FeedbackDialog component:', error);
          if (attempts < 3) {
            retry(); // Retry loading the component
          } else {
            fail(); // Give up after 3 attempts
          }
        },
      }, // Adjust the path as needed
    );

    console.log('Feedback component loaded:', loadedFeedbackComponent.value);
  });
});
</script>
